<!-- see https://github.com/negue/gewd/blob/master/libs/lazy/loader/lazy.component.ts -->
<ng-container #targetContainer></ng-container>
@if (componentLoading | async) {
  <app-loader></app-loader>
}
<!-- <ng-content *ngIf="componentLoading | async"
select="[isLoading]">
</ng-content> -->
